module.exports = __webpack_public_path__ + "img/dsci0044.327bc1bb.jpg";